import { type ClassValue, clsx } from 'clsx';

export default function cn(...classNames: ClassValue[]): string {
  return clsx(classNames);
}
